import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';
import type { MarketConfig } from '@/types';
import { normalizeMarketQuestion } from '@/utils';

interface PriceChartHeaderProps {
  markets: Array<MarketConfig & { value: number }>;
}

export function PriceChartHeader({ markets }: PriceChartHeaderProps) {
  const { t } = useT();

  if (!markets.length) return null;

  const singleMarketLabel = markets.length <= 1 ? t('market.chance') : '';

  function renderHeaderMarkets(market) {
    const marketName = normalizeMarketQuestion(market);
    const marketValue = Number.isFinite(market.value) ? `${(market.value * 100).toFixed(0)}%` : '-';
    return (
      <Box key={market.marketId} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: market.color,
          }}
        />
        <Typography
          variant="body2"
          component="span"
          sx={{ fontSize: '0.8125rem', fontWeight: 600, color: 'text.secondary' }}
        >
          {marketName}:{' '}
          <Box
            component="span"
            sx={{ fontWeight: 800, fontSize: '0.8125rem', color: 'text.primary' }}
          >
            {marketValue} {singleMarketLabel}
          </Box>
        </Typography>
      </Box>
    );
  }

  const renderHeaderMarketsList = markets.map(renderHeaderMarkets);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 4.5,
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>{renderHeaderMarketsList}</Box>
    </Box>
  );
}
